import I18n from 'I18n';
import { useEffect, useState } from 'react';
import { InputGroup } from 'foundations-components/transitional/components/InputGroup';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import UISelect from 'UIComponents/input/UISelect';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DISALLOWED_URL_PARAMETERS, getDisplayValue, getFullUrl, getProtocol } from '../../utils/urlUtils';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultProtocolValue = 'https://';
const getUnsupportedParameterKeys = urlString => {
  let url;
  try {
    url = new URL(urlString);
  } catch (err) {
    if (err instanceof TypeError) {
      return [];
    } else {
      throw err;
    }
  }
  const searchParameters = url.searchParams;
  const unsupportedParameterKeys = [];
  searchParameters.forEach((value, key) => {
    if (DISALLOWED_URL_PARAMETERS.includes(key) && value) {
      unsupportedParameterKeys.push(key);
    }
  });
  return unsupportedParameterKeys;
};
const getValidationMessage = urlString => {
  const unsupportedParameterKeys = getUnsupportedParameterKeys(urlString);
  if (unsupportedParameterKeys.length > 0) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.customerDataFilters.FilterOperatorStandardUrlInput.error.unsupportedParameters",
      options: {
        listOfParameters: I18n.formatList(unsupportedParameterKeys)
      }
    });
  } else {
    return null;
  }
};
export default function FilterOperatorStandardUrlInput(props) {
  const {
    disabled,
    error,
    value,
    onBlur,
    onChange,
    inputUse
  } = props;
  const isError = error.get('error');
  const errorMessage = error.get('message');
  const initialProtocol = getProtocol(value) || defaultProtocolValue;
  const [protocol, setProtocol] = useState(!disabled ? initialProtocol : defaultProtocolValue);
  const [url, setUrl] = useState(!disabled && value ? getDisplayValue(value) : '');
  useEffect(() => {
    if (disabled) {
      setProtocol(defaultProtocolValue);
      setUrl('');
    } else if (value) {
      setProtocol(getProtocol(value) || defaultProtocolValue);
      setUrl(getDisplayValue(value));
    }
  }, [disabled, value]);
  const handleProtocolChange = evt => {
    const newProtocol = evt.target.value;
    const newValue = getFullUrl(url, newProtocol);
    onChange(syntheticEvent(newValue));
    setProtocol(newProtocol);
  };
  const handleDomainChange = evt => {
    const {
      target: {
        value: currentValue
      }
    } = evt;
    const nextProtocol = getProtocol(currentValue) || protocol || defaultProtocolValue;
    setProtocol(nextProtocol);
    const nextDisplayValue = getDisplayValue(currentValue);
    setUrl(nextDisplayValue);
    const nextValue = nextDisplayValue ? getFullUrl(nextDisplayValue, nextProtocol) : '';
    return onChange(syntheticEvent(nextValue));
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(InputGroup, {
      required: true,
      use: "itemLeft",
      disabled: disabled,
      marginBlock: "200",
      children: [/*#__PURE__*/_jsx(FormControl, {
        "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
        children: /*#__PURE__*/_jsx(UISelect, {
          buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined,
          defaultValue: defaultProtocolValue,
          onChange: handleProtocolChange,
          options: [{
            text: 'https://',
            value: 'https://'
          }, {
            text: 'http://',
            value: 'http://'
          }],
          placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFiltersUI.customerDataFilters.FilterOperatorUrlInput.protocol.placeholder"
          }),
          value: protocol
        })
      }), /*#__PURE__*/_jsx(FormControl, {
        "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
        error: !disabled && isError,
        validationMessage: !disabled && isError ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [errorMessage, " ", getValidationMessage(value)]
        }) : null,
        children: /*#__PURE__*/_jsx(TextInput, {
          onBlur: () => {
            if (!disabled && onBlur) {
              onBlur();
            }
          },
          onChange: handleDomainChange,
          value: url.toString(),
          use: inputUse
        })
      })]
    }), /*#__PURE__*/_jsx(Text, {
      as: "small",
      display: "block",
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.customerDataFilters.FilterOperatorStandardUrlInput.annotation"
      })
    })]
  });
}